module.exports = __webpack_public_path__ + "static/media/demo-vid.7c824cc4.mp4";